import moment from 'moment-timezone';

export function millisecondsToStr(secs) {
  return moment(secs).tz("Europe/Warsaw").format('YYYY-MM-DD HH:mm:ss');
}
